import { formatDate, DATE_FORMATS } from '../../utils/dateFormatter';

// Consultation dates are defined in A ONE's timezone: due_at is end-of-day America/New_York,
// while assigned_at / deadlines are plain DATE-only strings. Formatting either with the
// viewer's local timezone drifts a day for non-Eastern parents, so:
//   - DATE-only ("YYYY-MM-DD") → build a local Date from the parts (no UTC shift)
//   - full timestamps → render the New York calendar day
export function fmtDay(value) {
  if (!value) return null;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number);
    return formatDate(new Date(y, m - 1, d), DATE_FORMATS.medium);
  }
  return formatDate(value, { ...DATE_FORMATS.medium, timeZone: 'America/New_York' });
}
